module.exports = __webpack_public_path__ + "static/banner-three-main-img-c5a9e63715d07c561299fef6d8466843.png";